import { Collection } from "../../types/collections.types";
import { GroupsOptions } from "../../types/groups.types";

export const GAP_ALLOCATOR_ENTITY = "gap-allocator";
export const GAP_PRIORITY_ENTITY = "gap_priority";

export const gapsCollection = {
	collection: GAP_ALLOCATOR_ENTITY,
	meta: { translations: [{ language: "pt-PT", plural: "Gaps", singular: "Gap" }] }
} as unknown as Collection;

export const gapPriorityFieldsQuery = [
	"*.*",
	"technician.user_id.first_name",
	"technician.user_id.last_name",
	"technician_schedule.user.first_name",
	"technician_schedule.user.last_name"
].join(",");

export const gapPriorityOptions = {
	groupsOptions: {
		navigateAfterCreate: () => "/gaps"
	} as GroupsOptions
};
